import type { GameAssets } from '../assets/GameAssets';
import { terrainConfig, type TerrainRenderAsset } from './TerrainRenderConfig';

const SEASONS = ['spring', 'summer', 'autumn', 'winter'] as const;

export interface TerrainAssetValidationReport {
  readonly required: readonly string[];
  readonly missing: readonly string[];
}

export function validateTerrainRenderAssets(assets: GameAssets): TerrainAssetValidationReport {
  const required = [...collectRequiredAssetKeys()].sort();
  const missing = required.filter((key) => !assets.reference[key]);
  return { required, missing };
}

function collectRequiredAssetKeys(): Set<string> {
  const keys = new Set<string>();
  addKey(keys, terrainConfig.base.default);
  addRenderAsset(keys, terrainConfig.base.visualPolish);
  for (const asset of Object.values(terrainConfig.base.variants)) addKey(keys, asset);

  addRenderAsset(keys, terrainConfig.overlays.shore);
  addRenderAsset(keys, terrainConfig.overlays.field);
  for (const asset of terrainConfig.overlays.forest.assets) addKey(keys, asset);
  addRenderAsset(keys, terrainConfig.overlays.mountain);
  addRenderAsset(keys, terrainConfig.overlays.workyard);

  for (const asset of Object.values(terrainConfig.roads.visualPolish)) addRenderAsset(keys, asset);
  for (const asset of Object.values(terrainConfig.water.visualPolish)) addRenderAsset(keys, asset);
  for (const asset of Object.values(terrainConfig.water.default)) addKey(keys, asset);
  for (const asset of terrainConfig.water.details.shore) addKey(keys, asset);
  for (const asset of terrainConfig.water.details.river) addKey(keys, asset);

  return keys;
}

function addRenderAsset(keys: Set<string>, asset: TerrainRenderAsset): void {
  addKey(keys, asset.asset);
  if (!asset.seasonal) return;
  for (const season of SEASONS) addKey(keys, `seasonal/${season}/${asset.seasonal}`);
}

function addKey(keys: Set<string>, key: string): void {
  keys.add(key);
}
